import { render, staticRenderFns } from "./LottoSetsRate.vue?vue&type=template&id=0d721665&"
import script from "./LottoSetsRate.vue?vue&type=script&lang=js&"
export * from "./LottoSetsRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports